var React = require('react');

function Hammer (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M19.64 405l255.1-238.17a97 97 0 0 0 9.85 12l49.14 49.14a97.23 97.23 0 0 0 11.44 9.41L107 492.36A61.84 61.84 0 1 1 19.64 405z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M435.56 261.81l11.31-11.31L418 221.6a63.73 63.73 0 0 1-61.61-16.35l-49.14-49.14a64 64 0 0 1-18.75-45.25V92.11L198 46.86a160 160 0 0 1 226.28 0l45.25 45.25a63.73 63.73 0 0 1 16.35 61.61l28.9 28.9 11.31-11.31a16 16 0 0 1 22.63 0l22.63 22.63a16 16 0 0 1 0 22.62l-90.51 90.51a16 16 0 0 1-22.63 0l-22.63-22.63a16 16 0 0 1-.02-22.63z","className":"fa-primary","key":2})]);
}

Hammer.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Hammer;

Hammer.default = Hammer;
